import type { FiboSearchRequest } from './types';

export const FIBO_QUERY_KEYS = {
  default: () => ['fibo'] as const,
  search: (params?: FiboSearchRequest) => [...FIBO_QUERY_KEYS.default(), 'search', params] as const,
};
